import * as React from 'react'
import { OnboardingComponentProps } from '.'
import { DasherPhone, DasherHotBag } from '../../atoms/icons'
import DasherExcitedAnimation from '../../atoms/dasher-excited'

export const SvgComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ type, width, height }) => {
    const widthInt = parseInt(width, 10)
    const heightInt = parseInt(height, 10)
    switch (type) {
      case 'DasherPhone':
        return <DasherPhone width={widthInt} height={heightInt} />
      case 'DasherHotBag':
        return <DasherHotBag width={widthInt} height={heightInt} />
      case 'DasherExcitedAnimation':
        return <DasherExcitedAnimation />
      default:
        return null
    }
  }
)
